import { CanvasSkeleton } from "@app/components/WidgetStudio/Canvas/skeletons/DesktopSkeleton/CanvasSkeleton";
import Logo from "@app/assets/svg/logo.svg";
import { AssetImporter } from "@app/components/AssetImporter";

export const DesktopSkeletonBanner = () => {
  return (
    <CanvasSkeleton className="flex items-center justify-center h-52 w-full rounded-none">
      <AssetImporter name="logoV" className="h-10 text-input" />
    </CanvasSkeleton>
  );
};
